import { gql } from 'graphql-tag';
import {
  specificResourceRequestWithAllocationsFragment,
  mergedResourceRequestsFragment,
  specificProjectFragmentLegacy
} from '~/modules/resourcing/common/fragments';

const resourceRequestQuery = gql`
  query Eager_getResourceRequest(
    $id: String!
    $includeMergeResourceRequests: Boolean = false
  ) {
    resourceRequest(id: $id) {
      mergedResourceRequests @include(if: $includeMergeResourceRequests) {
        ...MergedResourceRequestsFragment
      }
      ...SpecificResourceRequestWithAllocation
      project {
        permittedActionUris
        ...SpecificProjectFragmentLegacy
      }
    }
  }
  ${mergedResourceRequestsFragment}
  ${specificResourceRequestWithAllocationsFragment}
  ${specificProjectFragmentLegacy}
`;

export default resourceRequestQuery;
